module.exports = __webpack_public_path__ + "img/help_03.dbe09e40.png";